/**
 * Datum turnaje se v celé aplikaci (i ve Firebase) drží jako řetězec
 * "DD.MM.RRRR". Tyhle funkce jsou jediné místo, kde se ten formát řeší.
 */

export const CZECH_MONTHS = [
  "Leden",
  "Únor",
  "Březen",
  "Duben",
  "Květen",
  "Červen",
  "Červenec",
  "Srpen",
  "Září",
  "Říjen",
  "Listopad",
  "Prosinec",
];

/** Zkratky dnů, týden začíná pondělím. */
export const CZECH_WEEKDAYS = ["Po", "Út", "St", "Čt", "Pá", "So", "Ne"];

export const formatCzechDate = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${day}.${month}.${date.getFullYear()}`;
};

export const getTodayCzech = (): string => formatCzechDate(new Date());

/** Vrací null, pokud řetězec není platné datum (např. 31.02.2026). */
export const parseCzechDate = (value: string): Date | null => {
  const match = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec((value || "").trim());
  if (!match) return null;

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);

  const date = new Date(year, month - 1, day);
  // Nesmyslné datum si JS "opraví" na jiný den – to je pro nás chyba
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
};

export const isSameDay = (a: Date, b: Date): boolean =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

/**
 * 42 dní (6 týdnů) pokrývajících zobrazený měsíc včetně dorovnání
 * z okolních měsíců – díky pevné délce kalendář nepřeskakuje.
 */
export const getCalendarDays = (year: number, month: number): Date[] => {
  const firstOfMonth = new Date(year, month, 1);
  // getDay(): 0 = neděle; chceme 0 = pondělí
  const offset = (firstOfMonth.getDay() + 6) % 7;

  return Array.from(
    { length: 42 },
    (_, index) => new Date(year, month, 1 - offset + index)
  );
};
